import { OptionsDeleteIcon } from 'assets/icons/OptionsDeleteIcon'
import { CheckableList } from 'components/CheckableList/CheckableList'
import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell, RightCell } from 'components/HonestTable/HonestTable.styled'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { NotYetAdded } from 'pages/Operations/Operations.styled'
import { useState } from 'react'
import { Button, Flex } from 'styling/GlobalStyles'
import { IShiftProgramBindingRow } from 'types/shiftProgramBindings.interface'
import { MOCK_SHIFT_PROGRAM_BINDINGS } from '../bindingsData'
import { BodyText, TitleText } from 'styling/Typography'

export const Bindings = ({ setStep, setState }: { setStep: (step: number) => void, setState?: any, state?: any }) => {

    const [adding, setAdding] = useState(false)

    const handleNext = () => setStep(5)
    const handleBack = () => setStep(3)

    const parseTasks = (data: any) => {
        return data ? data.data.map((item: any) => ({ label: item.name, value: item.id })) : []
    }

    const handleSelect = () => null
    const handleShiftsChange = (shifts: ISelectValue[]) => {

        setState?.((prev: Record<string, unknown>) => ({ ...prev, shifts }))
    }

    const parseShifts = (data: { data: { id: number; name: string }[] }) =>
        data.data.map((shift) => ({ label: shift.name, value: shift.id }))

    const columns: IHonestTableColumn<IShiftProgramBindingRow>[] = [
        {
            id: 'task',
            header: 'Task',
            sticky: true,
            minWidth: '14rem',
            cell: (item) => (
                <Cell>
                    <BodyText weight='600'>{item.task}</BodyText>
                </Cell>
            ),
        },
        {
            id: 'locations',
            header: 'Locations',
            fill: true,
            minWidth: '20rem',
            cell: (item) => (
                <Cell>
                    <BodyText grey>{item.locations.join(', ')}</BodyText>
                </Cell>
            ),
        },
        {
            id: 'workersPerLocation',
            header: 'Workers per location',
            align: 'right',
            minWidth: '12rem',
            cell: (item) => (
                <RightCell>
                    <BodyText>{item.workersPerLocation}</BodyText>
                </RightCell>
            ),
        },
        {
            id: 'delete',
            header: '',
            align: 'right',
            minWidth: '3rem',
            cell: () => (
                <RightCell>
                    <OptionsDeleteIcon />
                </RightCell>
            ),
        },
    ]

    return <>

        <Container>
            <ContainerHeader>
                <TitleText>Bindings</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <BodyText style={{ marginBottom: '1rem' }} grey>Optional. Bindings tell the scheduler which task templates to instantiate at which locations when the program fires. You can add or change them later from the program detail page.</BodyText>
                <HonestTable
                    columns={columns}
                    data={MOCK_SHIFT_PROGRAM_BINDINGS}
                    keyField='id'
                />
                {!adding ? <>
                    {MOCK_SHIFT_PROGRAM_BINDINGS.length === 0 && (
                        <NotYetAdded onClick={() => setAdding(true)} >
                            <BodyText grey >No bindings yet — add one or skip and configure later.</BodyText>
                        </NotYetAdded>
                    )}
                    <Button style={{ marginTop: '1rem' }} orangeBorder onClick={() => setAdding(true)} >Add Binding</Button>
                </> : <>

                    <Container style={{ marginTop: '1rem', border: '1px solid #ff9900' }} >
                        <ContainerContent>
                            <Flex gap='1rem' >
                                <Flex column gap='1rem' width='100%' >
                                    <HonestSelectAsyncInput
                                        link='task/template/overviews'
                                        labelText='Parent Task Template'
                                        onChange={handleSelect}
                                        name='parentTaskTemplate'
                                        placeholder='Search Task Templates'
                                        parserFunction={parseTasks}
                                    />
                                    <Input labelText='Workers per location' name='workersPerLocation' placeholder='15...' type='number' />
                                </Flex>
                                <CheckableList
                                    link='shifts'
                                    parserFunction={parseShifts}
                                    searchEnabled
                                    searchPlaceholder='Search shifts...'
                                    selected={[]}
                                    onChange={handleShiftsChange}
                                    selectedLabelText='Selected shifts'
                                    selectedPlaceholder='No shifts selected'
                                    listMaxHeight='16rem'
                                />
                            </Flex>
                            <Flex gap='1rem' mt='32'>
                                <Button onClick={handleBack}>Back</Button>
                                <Button orange onClick={handleNext} >Next</Button>
                            </Flex>
                        </ContainerContent>
                    </Container>
                </>}
            </ContainerContent>
        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleNext} >Next</Button>
        </Flex>
    </>
}